(function () {
    'use strict';

    function requestForProposalResponseContentController($scope, $timeout, $state, $rootScope,
        milestones, milestoneModalService, notifyService, requestForProposalStateService, toastr) {
        var vm = this;
        vm.rfpData = requestForProposalStateService.get();
        vm.rfpId = vm.rfpData.Id.split('/')[1];
        vm.canAdvance = false;
        vm.mode = 'Configure';
        vm.canDeleteInformationPart = true;
        vm.parentData = vm.rfpData.ResponseContent;
        vm.modelOptions = {
            updateOn: 'default blur',
            debounce: {
                "default": 1000,
                "blur": 0
            }
        };

        milestoneModalService.getMilestonesAndTemplates(milestones).then(function (milestonesAndTemplates) {
            if (milestonesAndTemplates.length > 0) {
                milestoneModalService.openModal(milestonesAndTemplates);
            }
        });

        vm.updateRfp = function (fieldName) {
            $timeout(function() {
                if (fieldName) {
                    notifyService.notify('You updated the ' + fieldName + 'for the RFP Response');
                }

                requestForProposalStateService.update(vm.rfpData);
            }, 0);
        }

        vm.togglerfpResponseContentReorderMode = function () {
            if (!$rootScope.rfpResponseContentReorderMode) {
                $rootScope.rfpResponseContentReorderModeToast = toastr.info('You are currently reordering the rfp response content',
                    {
                        timeOut: 0,
                        extendedTimeOut: 0,
                        closeButton: true,
                        closeHtml: "<button>Stop reordering</button>",
                        onHidden: function () {
                            $rootScope.rfpResponseContentReorderMode = false;
                        }
                    });
            } else {
                if ($rootScope.rfpResponseContentReorderModeToast) {
                    toastr.clear($rootScope.rfpResponseContentReorderModeToast);
                    delete $rootScope.rfpResponseContentReorderModeToast;
                }
            }

            $rootScope.rfpResponseContentReorderMode = !$rootScope.rfpResponseContentReorderMode;
        }

        vm.toggleRfpResponseContentPreviewMode = function () {
            if (!$rootScope.rfpResponseContentPreviewMode) {
                $rootScope.rfpResponseContentPreviewModeToast = toastr.info('You are currently previewing the rfp response content',
                    {
                        timeOut: 0,
                        extendedTimeOut: 0,
                        closeButton: true,
                        closeHtml: "<button>Stop previewing</button>",
                        onHidden: function () {
                            $rootScope.rfpResponseContentPreviewMode = false;
                            vm.mode = 'Configure';
                        }
                    });
            } else {
                if ($rootScope.rfpResponseContentPreviewModeToast) {
                    toastr.clear($rootScope.rfpResponseContentPreviewModeToast);
                    delete $rootScope.rfpResponseContentPreviewModeToast;
                }
            }

            $rootScope.rfpResponseContentPreviewMode = !$rootScope.rfpResponseContentPreviewMode;
            vm.mode = $rootScope.rfpResponseContentPreviewMode ? 'Display' : 'Configure';
        }

        vm.updateDocumentPrompt = function (documentData) {
            requestForProposalStateService.updateDocumentPromptForResponseContent(documentData);
        }

        vm.deleteUpload = function (documentData, blobIndex) {
            requestForProposalStateService.deleteUploadForResponseContent(documentData, blobIndex);
        }

        vm.removeInformationPart = function (informationPart, partIndex) {
            requestForProposalStateService.removeInformationPartFromResponseContent(informationPart, partIndex);
        }

        vm.syncQuestionSet = function (questionSetData) {
            requestForProposalStateService.syncRfpResponseQuestionSet(questionSetData);
        }

        vm.addingInformationPartType = '';
        vm.activateAddInformationPart = function (type) {
            vm.addingInformationPartType = type;
            vm.isAddingInformationPart = !vm.isAddingInformationPart;
        }

        vm.addInformationPart = function (informationPart) {
            requestForProposalStateService.addInformationPartToResponseContent(informationPart);
        }
    }

    requestForProposalResponseContentController.$inject = ['$scope', '$timeout', '$state', '$rootScope',
        'milestones', 'milestoneModalService', 'notifyService', 'requestForProposalStateService', 'toastr'];

    angular.module('ecap.requestForProposal').controller('requestForProposalResponseContentController', requestForProposalResponseContentController);
})();
